import { fmt, LOGO_URL } from "@/lib/feedModels";

const formatDate = () =>
  new Date().toLocaleString("id-ID", {
    day: "2-digit",
    month: "long",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });

export default function CattlePrintReport({ cattle, showPrice }) {
  if (!cattle) return null;

  const weights = cattle.weights || [];
  const first = weights.length ? weights[0].weight : null;
  const last = weights.length ? weights[weights.length - 1].weight : null;
  const totalGain = first !== null && last !== null ? last - first : null;

  return (
    <div id="print-area" data-testid="cattle-print-report" className="hidden bg-white text-[#4A2E1A] p-8">
      <div className="border-b-2 border-[#A06E4D] pb-4 mb-6 flex justify-between items-center">
        <div className="flex items-center gap-3">
          <img src={LOGO_URL} alt="Sembada Satwa" className="w-16 h-16 object-contain" />
          <div>
            <h1 className="text-2xl font-extrabold tracking-tight text-[#8A5230]">Sembada Satwa</h1>
            <p className="text-sm text-[#A06E4D]">Laporan Data & Tren Bobot Sapi</p>
          </div>
        </div>
        <p className="text-xs text-[#A06E4D]">{formatDate()}</p>
      </div>

      <table className="w-full text-sm mb-6">
        <tbody>
          <tr className="border-b border-[#E0A988]/50">
            <td className="py-2 font-semibold">Nama Sapi</td>
            <td className="py-2 text-right">{cattle.name}</td>
          </tr>
          <tr className="border-b border-[#E0A988]/50">
            <td className="py-2 font-semibold">Nomor Sapi</td>
            <td className="py-2 text-right font-mono-num">{cattle.cattle_number}</td>
          </tr>
          <tr className="border-b border-[#E0A988]/50">
            <td className="py-2 font-semibold">Status</td>
            <td className="py-2 text-right">{cattle.status}</td>
          </tr>
          {showPrice && cattle.buy_price != null && (
            <tr className="border-b border-[#E0A988]/50">
              <td className="py-2 font-semibold">Harga Beli</td>
              <td className="py-2 text-right font-mono-num">
                Rp {Number(cattle.buy_price).toLocaleString("id-ID")}
              </td>
            </tr>
          )}
        </tbody>
      </table>

      <h2 className="text-base font-bold mb-2 text-[#8A5230]">Riwayat & Tren Bobot</h2>
      {weights.length === 0 ? (
        <p className="text-sm text-[#A06E4D]">Belum ada data bobot.</p>
      ) : (
        <>
          <table className="w-full text-sm border border-[#E0A988]/70 mb-4">
            <thead>
              <tr className="bg-[#F7E5D2]">
                <th className="py-2 px-3 text-left font-semibold border-b border-[#E0A988]/70">Periode</th>
                <th className="py-2 px-3 text-right font-semibold border-b border-[#E0A988]/70">Bobot</th>
                <th className="py-2 px-3 text-right font-semibold border-b border-[#E0A988]/70">Perubahan</th>
              </tr>
            </thead>
            <tbody>
              {weights.map((w, i) => {
                const prev = i > 0 ? weights[i - 1].weight : null;
                const d = prev === null ? null : w.weight - prev;
                return (
                  <tr key={i} className="border-b border-[#E0A988]/40">
                    <td className="py-2 px-3">{w.month}</td>
                    <td className="py-2 px-3 text-right font-mono-num font-bold">{fmt(w.weight)} kg</td>
                    <td className="py-2 px-3 text-right font-mono-num">
                      {d === null ? "—" : `${d > 0 ? "+" : ""}${fmt(d)} kg`}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          <table className="w-full text-sm border border-[#E0A988]/70">
            <tbody>
              <tr className="border-b border-[#E0A988]/40">
                <td className="py-2 px-3 font-semibold">Bobot Awal</td>
                <td className="py-2 px-3 text-right font-mono-num">{fmt(first)} kg</td>
              </tr>
              <tr className="border-b border-[#E0A988]/40">
                <td className="py-2 px-3 font-semibold">Bobot Terkini</td>
                <td className="py-2 px-3 text-right font-mono-num font-bold">{fmt(last)} kg</td>
              </tr>
              <tr className="bg-[#FBF3E8]">
                <td className="py-2 px-3 font-semibold">Total Kenaikan/Penurunan</td>
                <td className="py-2 px-3 text-right font-mono-num font-bold">
                  {totalGain === null ? "—" : `${totalGain > 0 ? "+" : ""}${fmt(totalGain)} kg`}
                </td>
              </tr>
            </tbody>
          </table>
        </>
      )}

      <p className="text-xs text-[#A06E4D] mt-8">
        Dicetak dari Sembada Satwa — Menu Data Sapi
      </p>
    </div>
  );
}
